import { render, staticRenderFns } from "./mTrain.vue?vue&type=template&id=77287d5d&scoped=true&"
import script from "./mTrain.vue?vue&type=script&lang=js&"
export * from "./mTrain.vue?vue&type=script&lang=js&"
import style0 from "./mTrain.vue?vue&type=style&index=0&id=77287d5d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77287d5d",
  null
  
)

export default component.exports